module.exports = __webpack_public_path__ + "static/img/staff-active.7c83b77.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menu/staff-active.png
// module id = bdtf
// module chunks = 58